module.exports = __webpack_public_path__ + "img/walletBox23.85e3993a.png";